// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"28":"ccc2ae10","120":"ff3b19ea","856":"d9eb022f"}[chunkId] + ".js";
};